import './members.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';

import {
  destroyMember,
  inviteMember,
  updateMember
} from '../../actions/member';
import LoupeGreenLight from '../../res/img/loupe_green_light.svg';
import Profile from '../../res/img/member.svg';
import Navigation from '../Navigation/global';

interface IProps {
  members: Member[];
  groups: Group[];
  inviteMember: (member: Member) => void;
  updateMember: (member: Member) => void;
  destroyMember: (member: Member) => void;
}

interface IState {
  keyword: string;
  currentMember: Member | null;
  invitationEmail: string;
}

class MembersComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      keyword: '',
      currentMember: null,
      invitationEmail: ''
    };

    this.onChangeKeyword = this.onChangeKeyword.bind(this);
    this.onChangeInvitationEmail = this.onChangeInvitationEmail.bind(this);
    this.sendInvitation = this.sendInvitation.bind(this);
    this.onBlurMemberItem = this.onBlurMemberItem.bind(this);
  }

  render() {
    return (
      <div id="AdminMembers">
        <Navigation group="システム管理" />

        <div id="Tabs">
          <div className="Tab TabSelected">メンバー管理</div>
          <Link to={'/admin/groups'}>
            <div className="Tab">グループ管理</div>
          </Link>
        </div>

        <div id="Content">
          <div id="ContentLeft">
            <div id="AllMembers">
              <label>すべてのメンバー</label>
              <div className="Search">
                <img src={LoupeGreenLight} />
                <input
                  className="InputText"
                  value={this.state.keyword}
                  onChange={this.onChangeKeyword}
                />
              </div>
              <div className="Members">
                {this.props.members
                  .filter(
                    member =>
                      member.nameLast.includes(this.state.keyword) ||
                      member.nameFirst.includes(this.state.keyword) ||
                      String(member.id).includes(this.state.keyword)
                  )
                  .sort((a, b) => (a.archived && !b.archived ? 1 : -1))
                  .map(member => (
                    <div
                      key={member.id}
                      className={
                        this.state.currentMember !== null &&
                        member.id === this.state.currentMember.id
                          ? 'Member MemberSelected'
                          : 'Member'
                      }
                      onMouseUp={this.selectMember.bind(this, member)}
                    >
                      <img
                        src={member.profile !== null ? member.profile : Profile}
                      />
                      <span>
                        {member.nameLast}
                        {member.nameFirst}
                      </span>
                    </div>
                  ))}
              </div>
            </div>

            <div id="AddMember">
              <label>メンバーの追加</label>
              <div className="Search">
                <img src={LoupeGreenLight} />
                <input
                  className="InputText"
                  placeholder="メールアドレスを入力"
                  onKeyUp={this.sendInvitation}
                  value={this.state.invitationEmail}
                  onChange={this.onChangeInvitationEmail}
                />
              </div>
            </div>
          </div>
          {this.state.currentMember !== null ? (
            <div id="ContentRight">
              <div id="MemberTitle">
                <img
                  src={
                    this.state.currentMember.profile !== null
                      ? this.state.currentMember.profile
                      : Profile
                  }
                />
                <span>
                  {this.state.currentMember.nameLast +
                    this.state.currentMember.nameFirst}
                </span>
                {this.state.currentMember.archived ? (
                  <span className="Archived">（アーカイブ）</span>
                ) : null}
              </div>

              <div className="MemberInformation">
                <label>従業員コード</label>
                <span>{this.state.currentMember.id}</span>
              </div>

              <div className="MemberInformation">
                <label>名前（姓）</label>
                <input
                  className="InputText"
                  value={this.state.currentMember.nameLast}
                  onChange={this.onChangeMemberItem.bind(this, 'nameLast')}
                  onBlur={this.onBlurMemberItem}
                />
              </div>

              <div className="MemberInformation">
                <label>名前（名）</label>
                <input
                  className="InputText"
                  value={this.state.currentMember.nameFirst}
                  onChange={this.onChangeMemberItem.bind(this, 'nameFirst')}
                  onBlur={this.onBlurMemberItem}
                />
              </div>

              <div className="MemberInformation">
                <label>メールアドレス</label>
                <input
                  className="InputText"
                  value={this.state.currentMember.email}
                  onChange={this.onChangeMemberItem.bind(this, 'email')}
                  onBlur={this.onBlurMemberItem}
                />
              </div>

              <div className="MemberInformation">
                <label>電話番号</label>
                <input
                  className="InputText"
                  value={this.state.currentMember.phone}
                  onChange={this.onChangeMemberItem.bind(this, 'phone')}
                  onBlur={this.onBlurMemberItem}
                />
              </div>

              <div id="MemberGroups">
                <label>所属グループ</label>
                {this.props.groups
                  .filter(group =>
                    group.members.includes(
                      (this.state.currentMember as Member).id
                    )
                  )
                  .map(group => (
                    <span>{group.title}</span>
                  ))}
              </div>
              {!this.state.currentMember.archived ? (
                <button
                  id="ArchiveMember"
                  onMouseUp={this.archiveMember.bind(
                    this,
                    this.state.currentMember
                  )}
                >
                  アーカイブ
                </button>
              ) : (
                <button
                  id="ArchiveMember"
                  onMouseUp={this.unarchiveMember.bind(
                    this,
                    this.state.currentMember
                  )}
                >
                  アクティブに戻す
                </button>
              )}

              <button
                id="DeleteMember"
                onMouseUp={this.destroyMember.bind(
                  this,
                  this.state.currentMember
                )}
              >
                削除
              </button>
            </div>
          ) : (
            <div id="ContentRight" />
          )}
        </div>
      </div>
    );
  }

  selectMember(member: Member, e: any) {
    this.setState({
      currentMember: member
    });
  }

  onChangeMemberItem(item: string, e: any) {
    const member = Object.assign({}, this.state.currentMember);

    if (item === 'id') {
      member.id = e.target.value;
    } else if (item === 'email') {
      member.email = e.target.value;
    } else if (item === 'phone') {
      member.phone = e.target.value;
    } else if (item === 'nameLast') {
      member.nameLast = e.target.value;
    } else if (item === 'nameFirst') {
      member.nameFirst = e.target.value;
    }

    this.setState({
      currentMember: member
    });
  }

  onBlurMemberItem(e: any) {
    const member = Object.assign({}, this.state.currentMember);
    this.props.updateMember(member);
  }

  onChangeKeyword(e: any) {
    this.setState({
      keyword: e.target.value
    });
  }

  onChangeInvitationEmail(e: any) {
    this.setState({
      invitationEmail: e.target.value
    });
  }

  archiveMember(member: Member, e: any) {
    if (confirm('このメンバーをアーカイブします')) {
      member.archived = true;
      member.token = '';
      this.props.updateMember(member);
    }
  }

  unarchiveMember(member: Member, e: any) {
    if (confirm('このメンバーをアクティブに戻します')) {
      member.archived = false;
      this.props.updateMember(member);
    }
  }

  destroyMember(member: Member, e: any) {
    if (confirm('このメンバーを削除します')) {
      this.props.destroyMember(member);
    }
  }

  sendInvitation(e: any) {
    if (e.keyCode === 13) {
      const member = new Member();
      member.email = this.state.invitationEmail;
      this.props.inviteMember(member);
      this.setState({
        invitationEmail: ''
      });
    }
  }
}

const mapStateToProps = (state: any) => ({
  members: state.Member,
  groups: state.Group
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    inviteMember(member: Member) {
      dispatch(inviteMember(member));
    },
    updateMember(member: Member) {
      dispatch(updateMember(member));
    },
    destroyMember(member: Member) {
      dispatch(destroyMember(member));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembersComponent);



// WEBPACK FOOTER //
// ./src/components/Admin/members.tsx